import React from "react";

import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaMinus } from "react-icons/fa";
import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { API_URL } from "../../../api/index";
import {
  Autocomplete,
  Box,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

function SpeComCreate() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [treatmentLists, setTreatmentLists] = useState([]);
  const [unitArr, setUnitArr] = useState([]);
  const [showUnitLists, setShowUnitLists] = useState([]);
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [description, setDescription] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState(0);
  const [totalCost, setTotalCost] = useState("");
  const [doctorLists, setDoctorLists] = useState([]);
  const [doctorID, setDoctorID] = useState("");
  const [treatmentID, setTreatmentID] = useState("");
  const [commission, setCommission] = useState("");
  const [commissionType, setCommissionType] = useState("");

  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    doctorID: "",
    treatmentID: "",
    commission: "",
  });
  console.log(showUnitLists);

  const SpecialCommissionCreate = (event) => {
    event.preventDefault();

    let required = {};

    if (!doctorID) {
      required.doctorID = "Doctor is required";
    }

    if (!treatmentID) {
      required.treatmentID = "Treatment is required";
    }

    if (!commissionType) {
      required.commissionType = "Commission Type is required";
    }

    if (!commission) {
      required.commission = "Commission is required";
    }

    if (commissionType === "Percent" && commission > 100) {
      required.commission = "Percentage cannot exceed 100";
    }

    if (Object.keys(required).length > 0) {
      setErrors(required);
      return;
    }

    setErrors({
      doctorID: "",
      treatmentID: "",
      commissionType: "",
      commission: "",
    });

    const data = {
      relatedDoctor: doctorID,
      relatedTreatment: treatmentID,
      // commissionPercent:
      //   commissionType === "percentage" ? Number(commission) : 0,
      commissionAmount:
        commissionType === "Amount" || commissionType === "Percent"
          ? Number(commission)
          : 0,
      commissionType: commissionType,
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .post("special-commission", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Success",
          text: "Successfully Created!",
          icon: "success",
          confirmButtonText: "OK",
        });

        navigate("/special-commission");
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: err.response?.data?.message || "Something went wrong",
          icon: "error",
          confirmButtonText: "Cancel",
        });
      });

    setDoctorID("");
    setTreatmentID("");
    setCommission("");
  };
  const [searchKeyword, setSearchKeyword] = useState("");

  const handleTreatmentSearch = async (keyword) => {
    setSearchKeyword(keyword);
    try {
      const res = await api.get(`treatments?search=${keyword}`);
      setTreatmentLists(res.data.list);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const getTreatment = async () => {
      try {
        const res = await api.get("treatments");

        setTreatmentLists(res?.data.list);
        setTreatmentID("");
        console.log(res?.data.list, "treat list");
      } catch (err) {}
    };

    const getDoctorLists = async () => {
      const res = await api.get("doctors");

      setDoctorLists(res.data.data);
      setDoctorID("");
    };

    getDoctorLists();
    getTreatment();
  }, []);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/special-commission">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active mt-1">
                      Special Commission Create
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div class="card">
                <h4 className="px-4 pb-3 pt-4 fs-4">
                  Special Commission Create
                </h4>
                <div class="card-body pb-5 px-4">
                  {/* @if($com == null) */}
                  <form onSubmit={SpecialCommissionCreate}>
                    {/* @csrf */}
                    <div className="form-body">
                      <div className="row">
                        <div className="col-md-3">
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                              Related Doctor{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                              select
                              fullWidth
                              size="small"
                              value={doctorID}
                              onChange={(e) => setDoctorID(e.target.value)}
                              SelectProps={{ displayEmpty: true }}
                            >
                              <MenuItem value="">
                                <em>Select Doctor</em>
                              </MenuItem>

                              {doctorLists?.map((option) => (
                                <MenuItem key={option._id} value={option._id}>
                                  {option.name}
                                </MenuItem>
                              ))}
                            </TextField>

                            {errors.doctorID && (
                              <div className="text-danger">
                                {errors.doctorID}
                              </div>
                            )}
                          </Box>
                        </div>
                        <div className="col-md-3">
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            Related Treatment{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Autocomplete
                            value={
                              treatmentLists.find(
                                (t) => t._id === treatmentID,
                              ) || null
                            }
                            onChange={(event, newValue) =>
                              setTreatmentID(newValue?._id || "")
                            }
                            onInputChange={(event, newInputValue) => {
                              if (newInputValue.length >= 1)
                                handleTreatmentSearch(newInputValue);
                            }}
                            options={treatmentLists}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) =>
                              option._id === value._id
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Search Treatment..." // <-- only placeholder
                                size="small"
                                error={!!errors.treatmentID}
                                helperText={errors.treatmentID}
                                variant="outlined" // optional styling
                                InputLabelProps={{ shrink: false }} // ensures no floating label
                              />
                            )}
                            sx={{ width: "100%" }}
                            freeSolo
                            disablePortal
                          />
                        </div>
                        <div className="col-md-2">
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                              Is Percentage{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <div>
                              <label>
                                <input
                                  type="radio"
                                  name="commissionType"
                                  value="Percent"
                                  checked={commissionType === "Percent"}
                                  onChange={(e) =>
                                    setCommissionType(e.target.value)
                                  }
                                />
                                Yes
                              </label>
                              <label style={{ marginLeft: "10px" }}>
                                <input
                                  type="radio"
                                  name="commissionType"
                                  value="Amount"
                                  checked={commissionType === "Amount"}
                                  onChange={(e) =>
                                    setCommissionType(e.target.value)
                                  }
                                />
                                No
                              </label>
                            </div>

                            {errors.commissionType && (
                              <div className="text-danger">
                                {errors.commissionType}
                              </div>
                            )}
                          </Box>
                        </div>
                        <div className="col-md-3">
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                              Commission <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              type="text"
                              name="balance"
                              id="name"
                              value={commission}
                              onChange={(e) => setCommission(e.target.value)}
                            />

                            {errors.commission && (
                              <div className="text-danger">
                                {errors.commission}
                              </div>
                            )}
                          </Box>
                        </div>
                      </div>

                      <div className="form-actions mt-3">
                        <div className="row">
                          <div className="col-md-12 d-flex justify-content-end">
                            <button type="submit" className="btn btn-primary">
                              Create
                            </button>
                            &nbsp;
                            <button type="button" className="btn btn-danger">
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <!-- /.row (main row) --> */}
                </div>
                {/*<!-- /.container-fluid --> */}
              </div>
            </div>
          </section>
          {/* <!-- /.content --> */}
        </div>

        {/* <!-- /.content-wrapper --> */}

        {/* <!-- Control Sidebar --> */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default SpeComCreate;
